/** Path pattern of the read-only dashboard viewer for one dashboard.
 *  Used by `routes.tsx` to register the route. */
export const DASHBOARD_BY_ID_PATH = "/dashboard/:dashboardId";

/** Static link to one dashboard in the read-only viewer. Single place the
 *  URL shape lives, so widgets build links through it instead of pasting
 *  the string themselves. */
export const getDashboardPath = (dashboardId: string): string =>
  DASHBOARD_BY_ID_PATH.replace(":dashboardId", dashboardId);
